/**
 * @description: 员工小费收款明细报表
 * @author: lyr
*/
<template>
    <div class="or-yxsm-report">
        <div class="list">
            <el-form :inline="true" size="small" :model="list_form">
                <el-form-item label="收款时间">
                    <div class="clearfix" ref="list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="list_form.start_time"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="list_form.end_time"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="list_form.shop_id" filterable clearable placeholder="请选择门店" @change="changeShop($event)">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="收款员工">
                    <el-select v-model="list_form.admin_id" filterable clearable placeholder="请选择收款员工">
                        <el-option v-for="item in staff_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="员工工号">
                    <el-input placeholder="请输入员工工号" clearable v-model="list_form.work_number"></el-input>
                </el-form-item>
                <el-form-item label="评价">
                    <el-select v-model="list_form.evaluate" filterable clearable placeholder="请选择评价">
                        <el-option label="全部" value=""></el-option>
                        <el-option label="好评" value="3"></el-option>
                        <el-option label="中评" value="2"></el-option>
                        <el-option label="差评" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="listQuery">查询</el-button>
                    <el-button @click="listExport">导出</el-button>
                </el-form-item>
            </el-form>
            <el-row class="total-txt">
                <div class="item">总金额：{{total_amount}}</div>
                <div class="item">打赏总额：{{amount}}</div>
                <div class="item">追加总额：{{add_amount}}</div>
            </el-row>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="list_table">
                <el-table-column prop="create_time" label="收款时间"></el-table-column>
                <el-table-column prop="admin_name" label="收款员工"></el-table-column>
                <el-table-column prop="work_number" label="员工工号"></el-table-column>
                <el-table-column prop="total_amount" label="收款总额"></el-table-column>
                <el-table-column prop="amount" label="打赏金额"></el-table-column>
                <el-table-column prop="add_amount" label="追加金额"></el-table-column>
                <el-table-column prop="content" label="评价"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="list_page"
                :total="list_total"
                @current-change="getList">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: '',
        data() {
            return {
                loading: false,
                shop_list: [],
                staff_list: [],
                list_form: {
                    start_time: '',
                    end_time: '',
                    shop_id: '',
                    work_number: '',
                    admin_id: '',
                    evaluate: ''
				},
				list_table: [],
				list_page: 1,
                list_total: 0,
                total_amount: 0,
                amount: 0,
                add_amount: 0,
            }
        },
        mounted: function() {
            // 日期
            this.list_form.start_time = moment().format('YYYY-MM-DD 08:00');
            this.list_form.end_time = moment().add(1, 'day').format('YYYY-MM-DD 08:00');
            this.innitDate();
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                this.list_form.shop_id = this.shop_list[0].id;
                this.getStaffList(this.list_form.shop_id)
                this.setShopDefaultTime(this.list_form.shop_id)
                this.getList(1);
            })
        },
        methods: {
            setShopDefaultTime(shop_id) {
                let report_default_time = '1'
                let shop_report_default_time = this.$store.state.shop_report_default_time
                shop_report_default_time.forEach(item => {
                    if (shop_id == item.shop_id) {
                        report_default_time = item.report_default_time
                        if (report_default_time == '1') {
                            this.list_form.start_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.list_form.end_time = moment().add(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }else {
                            this.list_form.start_time = moment().subtract(1, 'day').hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                            this.list_form.end_time = moment().hour(8).minute(0).format('YYYY-MM-DD HH:mm');
                        }
                    }
                })
            },
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                }, function(start, end, label) {
                    _this.list_form.start_time = start.format('YYYY-MM-DD 08:00');
                    _this.list_form.end_time = end.format('YYYY-MM-DD 08:00');
                });
            },
            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            getStaffList: function(shop_id) {
                const _this = this;

                Vue.axios.post('user/getSearchList', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {
                            "shop_id": shop_id
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.staff_list = res.data.response.result;
                        _this.staff_list.unshift({
                            id: '',
                            name: '全部'
                        });
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            getList(page) {
				const _this = this;

				_this.loading = true;
				Vue.axios.post('FinanceReport2/getMerchantUserRewardList', {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": page,
							"page_size": _this.GLOBAL.PAGESIZE,
                            "start_time": _this.list_form.start_time,
                            "end_time": _this.list_form.end_time,
							"shop_id": _this.list_form.shop_id,
							"work_number": _this.list_form.work_number,
							"admin_id": _this.list_form.admin_id,
							"evaluate": _this.list_form.evaluate
						}
					},
					"comment": ""
				})
				.then(res => {
					if(res.data.response.result_code == "true") {
						if(page == 1) {
							_this.list_total = Number(res.data.response.result.count)
                            _this.total_amount = res.data.response.result.total_amount
                            _this.amount = res.data.response.result.amount
                            _this.add_amount = res.data.response.result.add_amount
						}
						_this.list_table = res.data.response.result.data;
						_this.loading = false;
					} else {
						Vue.timeoutfun(res.data.response.result_status, _this);
						layer.msg(res.data.response.error_msg);
					}
				})
				.catch(err => {
					layer.msg("出错啦");
				});
			},

            changeShop(val) {
                this.list_form.shop_id = val
                if (!!val) {
                    this.getStaffList(val)
                    this.setShopDefaultTime(val)
                }
            },

			// 查询
			listQuery() {
                this.list_page = 1
				this.getList(this.list_page);
            },
            
            listExport: function() {
                window.location.href = Vue.ctUrl + "FinanceReport2/exportMerchantUserRewardList" +
                    "?start_time=" + this.list_form.start_time +
                    "&end_time=" + this.list_form.end_time +
                    "&shop_id=" + this.list_form.shop_id +
                    "&work_number=" + this.list_form.work_number +
                    "&admin_id=" + this.list_form.admin_id +
                    "&evaluate=" + this.list_form.evaluate;
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>
    .total-txt {
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 10px;
        .item {
            margin-right: 40px;
        }
    }
</style>